@let parent = data().parent;
@if (parent) {
  <div class="container" (click)="navigateToParent()">
    <alg-left-menu-back-button>{{ parent.title }}</alg-left-menu-back-button>
  </div>
} @else if (elementType === 'group') {
  <div class="container buttons-section" data-testid="group-left-menu">
    <a
      class="size-l stroke left-menu alg-flex-1"
      [routerLink]="['groups', 'mine']"
      routerLinkActive="selected"
      alg-button
      icon="ph-duotone ph-users-three"
      i18n
    >
      Join
    </a>
    <a
      class="size-l stroke left-menu alg-flex-1"
      [routerLink]="['groups', 'manage']"
      routerLinkActive="selected"
      alg-button
      icon="ph-duotone ph-crown-simple"
      i18n
    >
      Manage
    </a>
  </div>
}

@if (nodes().length > 0) {
  <div class="tree-nav-container">
    <cdk-tree [dataSource]="nodes()" [treeControl]="treeControl">
      <cdk-nested-tree-node
        *cdkTreeNodeDef="let node"
        class="tree-node"
      >
        @switch (node.type) {
          @case ('chapter') {
            <div
              class="tree-nav-wrapper chapter"
              [ngClass]="{
                'selected': node.partialSelected,
                'locked': node.data.locked
              }"
              [attr.data-selected]="node.partialSelected ? 'true' : null"
              (click)="selectNode(node)"
            >
              <div class="tree-nav-left">
                @if (node.inL1) {
                  <div class="tree-nav-icon">
                    <i class="ph-duotone" (click)="toggleFolder(node)" [ngClass]="{
                      'ph-caret-right': !node.expanded,
                      'ph-caret-down': node.expanded
                    }"></i>
                  </div>
                } @else {
                  <div class="tree-nav-dot-wrapper">
                    <div class="tree-nav-dot"></div>
                  </div>
                }
                <div class="tree-nav-caption-wrapper">
                  @if (!node.inL1) {
                    <div class="tree-sub-nav-icon">
                      <i class="ph-duotone ph-caret-right"></i>
                    </div>
                  }
                  <div class="tree-nav-caption" [ngClass]="{ 'children-caption': !node.inL1 }">
                    {{ node.label }}
                    @if (node.data.associatedGroupNames && node.data.associatedGroupNames.length > 0) {
                      <span class="alg-text-small">
                        (<span>{node.data.associatedGroupNames.length, plural, =1 {via group} other {via groups}}:</span>
                        {{ node.data.associatedGroupNames.join(', ') }})
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div class="tree-nav-right">
                @if (node.data.score) {
                  <alg-score-ring
                    [currentScore]="node.data.score.currentScore"
                    [bestScore]="node.data.score.bestScore"
                    [isValidated]="node.data.score.validated"
                    [compact]="true"
                  ></alg-score-ring>
                }
                @if (node.data.locked) {
                  <div
                    class="tree-nav-icon"
                    tooltipPosition="top"
                    i18n-algTooltip algTooltip="Your current access rights do not allow you to list the content of this chapter."
                    >
                    <i class="ph-duotone ph-lock-key"></i>
                  </div>
                }
              </div>
            </div>
          }
          @case ('skill-folder') {
            <div
              class="tree-nav-wrapper chapter"
              [ngClass]="{
                'selected': node.partialSelected,
                'locked': node.data.locked
              }"
              [attr.data-selected]="node.partialSelected ? 'true' : null"
              (click)="selectNode(node)"
            >
              <div class="tree-nav-left">
                @if (node.inL1) {
                  <div class="tree-nav-icon">
                    <i class="ph-duotone" [ngClass]="{
                      'ph-caret-right': !node.expanded,
                      'ph-caret-down': node.expanded
                    }"></i>
                  </div>
                } @else {
                  <div class="tree-nav-dot-wrapper">
                    <div class="tree-nav-dot"></div>
                  </div>
                }
                <div class="tree-nav-caption-wrapper">
                  @if (!node.inL1) {
                    <div class="tree-sub-nav-icon">
                      <i class="ph-duotone ph-caret-right"></i>
                    </div>
                  }
                  <div class="tree-nav-caption" [ngClass]="{ 'children-caption': !node.inL1 }">
                    {{ node.label }}
                    @if (node.data.associatedGroupNames && node.data.associatedGroupNames.length > 0) {
                      <span class="alg-text-small">
                        (<span>{node.data.associatedGroupNames.length, plural, =1 {via group} other {via groups}}:</span>
                        {{ node.data.associatedGroupNames.join(', ') }})
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div class="tree-nav-right">
                @if (elementType === 'skill' && node.data.score) {
                  <div class="tree-nav-skill-progress">
                    <alg-skill-progress
                      [bestScore]="node.data.score.bestScore"
                      [currentScore]="node.data.score.currentScore"
                    ></alg-skill-progress>
                  </div>
                }
                @if (node.data.locked) {
                  <div class="tree-nav-icon">
                    <i class="ph-duotone ph-lock-key"></i>
                  </div>
                }
              </div>
            </div>
          }
          @case ('skill-leaf') {
            <div
              class="tree-nav-wrapper"
              [ngClass]="{
                'selected': node.partialSelected,
                'locked': node.data.locked
              }"
              [attr.data-selected]="node.partialSelected ? 'true' : null"
              (click)="selectNode(node)"
              >
              <div class="tree-nav-left">
                @if (node.inL1) {
                  <div class="tree-nav-icon">
                    <i class="ph-duotone ph-graduation-cap"></i>
                  </div>
                } @else {
                  <div class="tree-nav-dot-wrapper">
                    <div class="tree-nav-dot"></div>
                  </div>
                }
                <div class="tree-nav-caption" [ngClass]="{ 'children-caption': !node.inL1 }">
                  {{ node.label }}
                  @if (node.data.associatedGroupNames && node.data.associatedGroupNames.length > 0) {
                    <span class="alg-text-small">
                      (<span>{node.data.associatedGroupNames.length, plural, =1 {via group} other {via groups}}:</span>
                      {{ node.data.associatedGroupNames.join(', ') }})
                    </span>
                  }
                </div>
              </div>
              <div class="tree-nav-right">
                @if (elementType === 'skill' && node.data.score) {
                  <alg-skill-progress
                    [bestScore]="node.data.score.bestScore"
                    [currentScore]="node.data.score.currentScore"
                  ></alg-skill-progress>
                }
                @if (node.data.locked) {
                  <div
                    class="tree-nav-icon"
                    tooltipPosition="top"
                    i18n-algTooltip algTooltip="Your current access rights do not allow you to list the content of this skill."
                  >
                    <i class="ph-duotone ph-lock-key"></i>
                  </div>
                }
              </div>
            </div>
          }
          @case ('group') {
            <div
              class="tree-nav-wrapper"
              [ngClass]="{
                'selected': node.data && node.partialSelected,
                'locked': node.data.locked
              }"
              [attr.data-selected]="node.partialSelected ? 'true' : null"
              (click)="selectNode(node)"
              >
              <div class="tree-nav-left">
                @if (node.inL1) {
                  <div class="tree-nav-icon">
                    <i class="ph-duotone" [ngClass]="{
                      'ph-caret-right': !node.expanded,
                      'ph-caret-down': node.expanded
                    }"></i>
                  </div>
                } @else {
                  <div class="tree-nav-dot-wrapper">
                    <div class="tree-nav-dot"></div>
                  </div>
                }
                <div class="tree-nav-caption-wrapper">
                  @if (!node.inL1 && node.hasChildren) {
                    <div class="tree-sub-nav-icon">
                      <i class="ph-duotone ph-caret-right"></i>
                    </div>
                  }
                  <div class="tree-nav-caption" [ngClass]="{ 'children-caption': !node.inL1 }">{{ node.label }}</div>
                </div>
              </div>
              <div class="tree-nav-right">
                @if (node.data.score) {
                  <alg-score-ring
                    [currentScore]="node.data.score.currentScore"
                    [bestScore]="node.data.score.bestScore"
                    [isValidated]="node.data.score.validated"
                    [compact]="true"
                  ></alg-score-ring>
                }
                @if (node.data.groupRelation.managership !== 'none') {
                  <div
                    class="tree-nav-icon"
                    [class.fade]="node.data.groupRelation.managership === 'descendant'"
                    tooltipPosition="top"
                    [algTooltip]="node.data.groupRelation.managership | i18nSelect : managershipTooltipCaptions"
                  >
                    <i class="ph-duotone ph-crown"></i>
                  </div>
                }
              </div>
            </div>
          }
          @case ('task') {
            <div
              class="tree-nav-wrapper"
              [ngClass]="{
                'selected': node.partialSelected,
                'locked': node.data.locked
              }"
              [attr.data-selected]="node.partialSelected ? 'true' : null"
              (click)="selectNode(node)"
              >
              <div class="tree-nav-left">
                @if (node.inL1) {
                  <div class="tree-nav-icon">
                    <i class="ph-duotone ph-files"></i>
                  </div>
                } @else {
                  <div class="tree-nav-dot-wrapper">
                    <div class="tree-nav-dot"></div>
                  </div>
                }
                <div class="tree-nav-caption" [ngClass]="{ 'children-caption': !node.inL1 }">
                  {{ node.label }}
                  @if (node.data.associatedGroupNames && node.data.associatedGroupNames.length > 0) {
                    <span class="alg-text-small">
                      (<span>{node.data.associatedGroupNames.length, plural, =1 {via group} other {via groups}}:</span>
                      {{ node.data.associatedGroupNames.join(', ') }})
                    </span>
                  }
                </div>
              </div>
              <div class="tree-nav-right">
                @if (node.data.score) {
                  <alg-score-ring
                    [currentScore]="node.data.score.currentScore"
                    [bestScore]="node.data.score.bestScore"
                    [isValidated]="node.data.score.validated"
                    [compact]="true"
                  ></alg-score-ring>
                }
                @if (node.data.locked) {
                  <div
                    class="tree-nav-icon"
                    tooltipPosition="top"
                    i18n-algTooltip algTooltip="Your current access rights do not allow you to start the activity."
                  >
                    <i class="ph-duotone ph-lock-key"></i>
                  </div>
                }
              </div>
            </div>
          }
        }

        <div class="tree-nested" [class.tree-invisible]="!node.expanded">
          <ng-container cdkTreeNodeOutlet></ng-container>
        </div>
      </cdk-nested-tree-node>
    </cdk-tree>
  </div>
} @else {
  <div class="empty-message">
    {elementType, select,
      group {You are not a member or manager of any group}
      other {There is no content to display}
    }
</div>
}
